import React, { forwardRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles.module.scss";
import { LoaderDots } from "../Loader";
import { useDevicePixelRatio } from "helpers/hooks";

function Modal({ isLoading }) {
  const dispatch = useDispatch();
  const dpr = useDevicePixelRatio();
  const apiloading = useSelector((state) => state.common.apiloading);
  const [isAuthPage, setIsAuthPage] = useState(false);

  const setLoaderStatus = async (status) => {
    let url = window.location.href;
    setIsAuthPage(url.includes("auth"));
    dispatch({ type: "API_LOADING", payload: status });
  };

  Modal.defaultProps = {
    setLoaderStatus,
    apiloading,
  };
  const size = dpr === 1.25 ? "15px" : "20px";
  return apiloading ? (
    <div>
      <div
        className={styles["container-modal"]}
        style={{
          paddingLeft: !isAuthPage ? 250 : 0,
        }}
      >
        <LoaderDots isLoading={apiloading} size={size} />
      </div>
    </div>
  ) : null;
}

const ModalRef = forwardRef(Modal);
export default ModalRef;

export function PageLoader() {
  const dpr = useDevicePixelRatio();
  const size = dpr === 1.25 ? "15px" : "20px";
  return (
    <div>
      <div
        className={styles["container-modal"]}
        style={{
          paddingLeft: 0,
        }}
      >
        <LoaderDots isLoading={true} size={size} />
      </div>
    </div>
  );
}
